import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // eslint-disable-next-line react/require-default-props
  label?: string;
  // eslint-disable-next-line react/require-default-props
  error?: string;
  // eslint-disable-next-line react/require-default-props
  touched?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  touched,
  id,
  className = '',
  ...props
}) => {
  const inputId = id || props.name;
  const hasError = touched && error;

  return (
    <div className="mb-2">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-700 mb-[4px]"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8510DF] focus:border-transparent ${
          hasError ? 'border-red-500' : 'border-gray-300'
        } ${className}`}
        {...props}
      />
      {hasError && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Input;
